import React from 'react';
import { StyledMarkdown, MarkdownLink } from '../../components';
export default function UiMarkdown({ model }) {
    const { content, textSize, orderedListAppearance } = model.content;
    return (React.createElement(StyledMarkdown, { renderers: {
            link: MarkdownLink
        }, textSize: textSize, orderedListAppearance: orderedListAppearance }, content));
}
//# sourceMappingURL=UiMarkdown.js.map